import i18next from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import resourcesToBackend from 'i18next-resources-to-backend'
import { initReactI18next } from 'react-i18next/initReactI18next'
import { fallbackLng, languages, defaultNS } from './settings'
import contactEn from './locales/en/contact.json'
import contactHr from './locales/hr/contact.json'
import heroEn from './locales/en/hero.json'
import heroHr from './locales/hr/hero.json'
import mainEn from './locales/en/main.json'
import mainHr from './locales/hr/main.json'

export const resources = {
  en: {
    contact: contactEn,
    hero: heroEn,
    main: mainEn,
  },
  hr: {
    contact: contactHr,
    hero: heroHr,
    main: mainHr,
  }
} as const

const runsOnServerSide = typeof window === 'undefined'

i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(resourcesToBackend((language: string, namespace: string) => import(`./locales/${language}/${namespace}.json`)))
  .init({
    supportedLngs: languages,
    fallbackLng,
    lng: undefined, // let's detect the language on client side
    fallbackNS: defaultNS,
    defaultNS,
    detection: {
      order: ['path', 'htmlTag', 'cookie', 'navigator']
    },
    preload: runsOnServerSide ? languages : [],
    resources: resources,
  })

export default i18next
